/* @flow */
// typecheck: ignore file
import React from 'react';
import Toast from 'components/Toast.jsx';
import Notice from 'components/Notice.jsx';

const ErrorToast = (props: {children?: any}) => (
  <Toast>
    <Notice color="lava" glyph="close">
      {props.children}
    </Notice>
  </Toast>
);

export default ErrorToast;



// WEBPACK FOOTER //
// ./src/components/ErrorToast.jsx